// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var Decco = require("decco/src/Decco.bs.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Log$SmartcutsMacros = require("./Log.bs.js");
var Util$SmartcutsMacros = require("../../bs-utils/src/Util.bs.js");
var DOM__File$SmartcutsMacros = require("./DOM__File.bs.js");
var DOM__Node$SmartcutsMacros = require("./DOM__Node.bs.js");
var OptionUtils$SmartcutsMacros = require("../../bs-utils/src/OptionUtils.bs.js");
var StringUtils$SmartcutsMacros = require("../../bs-utils/src/StringUtils.bs.js");
var DOM__Element$SmartcutsMacros = require("./DOM__Element.bs.js");
var DOM__EventType$SmartcutsMacros = require("./DOM__EventType.bs.js");
var DOM__HtmlElement$SmartcutsMacros = require("./DOM__HtmlElement.bs.js");
var Navigator__Clipboard$SmartcutsMacros = require("./Navigator/Navigator__Clipboard.bs.js");

var mvpEventTypesWithoutCapture = [
  "input",
  "change",
  "copy",
  "cut",
  "dragend",
  "wheel",
  "selectionchange"
];

var mvpEventTypesWithCapture = [
  "click",
  "contextmenu",
  "mouseup",
  "mousedown",
  "mousemove",
  "dragstart",
  "drop",
  "focus",
  "blur",
  "keydown",
  "keyup",
  "keypress",
  "paste"
];

function fromMouseEvent(mouseEvent) {
  var i = mouseEvent.button;
  if (i > 4 || i < 0) {
    return /* InvalidMouseButton */{
            _0: i
          };
  } else {
    return i;
  }
}

var MouseButtonPressed = {
  fromMouseEvent: fromMouseEvent
};

var _map = {"input":"input","button":"button","select":"select","div":"div"};

function tagNameToJs(param) {
  return param;
}

function tagNameFromJs(param) {
  return _map[param];
}

var _map$1 = {"text":"text","password":"password","file":"file","datetime":"datetime","datetimeLocal":"datetime-local","date":"date","month":"month","time":"time","week":"week","number":"number","range":"range","email":"email","url":"url","search":"search","tel":"tel","color":"color"};

var _revMap = {"text":"text","password":"password","file":"file","datetime":"datetime","datetime-local":"datetimeLocal","date":"date","month":"month","time":"time","week":"week","number":"number","range":"range","email":"email","url":"url","search":"search","tel":"tel","color":"color"};

function inputTypeToJs(param) {
  return _map$1[param];
}

function inputTypeFromJs(param) {
  return _revMap[param];
}

var _map$2 = {"beforepaste":"beforepaste","paste":"paste"};

function eventTypeToJs(param) {
  return param;
}

function eventTypeFromJs(param) {
  return _map$2[param];
}

function make(type_, data, dataType) {
  var clipboardData = new DataTransfer();
  clipboardData.setData(dataType, data);
  return new ClipboardEvent(type_, {
              clipboardData: clipboardData,
              dataType: dataType,
              data: data,
              bubbles: true,
              cancelable: true,
              composed: true
            });
}

function makeWithDataItems(type_, dataItems) {
  var clipboardData = Belt_Array.reduce(dataItems, new DataTransfer(), (function (clipboardData, param) {
          var data = param[1];
          var dataType = param[0];
          var exit = 0;
          if (dataType === "text/html") {
            switch (data.TAG | 0) {
              case /* Blob */0 :
                  exit = 1;
                  break;
              case /* String */2 :
                  clipboardData.setData(dataType, data._0);
                  break;
              case /* File */1 :
              case /* Promise */3 :
                  Util$SmartcutsMacros.logAndRaiseJsError("Unexpected data type and data combo");
                  break;
              
            }
          } else {
            exit = 1;
          }
          if (exit === 1) {
            if (data.TAG === /* Blob */0 && dataType.startsWith("image/")) {
              var file = DOM__File$SmartcutsMacros.makeWithBlob(data._0, "image.png", dataType, undefined, undefined);
              clipboardData.items.add(file);
            } else {
              Util$SmartcutsMacros.logAndRaiseJsError("Unexpected data type and data combo");
            }
          }
          return clipboardData;
        }));
  return new ClipboardEvent(type_, {
              clipboardData: clipboardData,
              bubbles: true,
              cancelable: true,
              composed: true
            });
}

function makeWithText(type_, text) {
  return make(type_, text, "text");
}

var $$ClipboardEvent$1 = {
  eventTypeToJs: eventTypeToJs,
  eventTypeFromJs: eventTypeFromJs,
  make: make,
  makeWithDataItems: makeWithDataItems,
  makeWithText: makeWithText
};

function ofElement(element) {
  var tagName = element.tagName.toLowerCase();
  if (tagName === "a") {
    return Caml_option.some(element);
  }
  
}

var HtmlAnchorElement = {
  ofElement: ofElement
};

function stringify(_nodeList) {
  return "nodeList";
}

function t__encode(v) {
  return Decco.arrayToJson(DOM__Node$SmartcutsMacros.ForSerialization.t__encode, v);
}

function t__decode(v) {
  return Decco.arrayFromJson(DOM__Node$SmartcutsMacros.ForSerialization.t__decode, v);
}

function fromNodeList(nodeList) {
  return $$Array.map(DOM__Node$SmartcutsMacros.ForSerialization.fromDomNode, Array.prototype.slice.call(nodeList));
}

function stringify$1(serializedNodeList) {
  return "[" + (StringUtils$SmartcutsMacros.join(", ", $$Array.to_list($$Array.map(DOM__Node$SmartcutsMacros.ForSerialization.stringify, serializedNodeList))) + "]");
}

var ForSerialization = {
  t__encode: t__encode,
  t__decode: t__decode,
  fromNodeList: fromNodeList,
  stringify: stringify$1
};

var $$NodeList = {
  stringify: stringify,
  ForSerialization: ForSerialization
};

function treatBlankValueAsNone(maybeString) {
  return OptionUtils$SmartcutsMacros.andThen((function (str) {
                if (str === "") {
                  return ;
                } else {
                  return str;
                }
              }), OptionUtils$SmartcutsMacros.map(maybeString, (function (prim) {
                    return prim.trim();
                  })));
}

function findLabelForIdOrName(nameOrId) {
  return Caml_option.nullable_to_opt(document.querySelector("label[for=" + (StringUtils$SmartcutsMacros.quote(nameOrId) + "]")));
}

function deduceNameOfInput(element) {
  var maybeNameAttribute = treatBlankValueAsNone(Caml_option.nullable_to_opt(element.getAttribute("name")));
  var label = Belt_Option.flatMap(treatBlankValueAsNone(element.id), findLabelForIdOrName);
  var maybeLabel = label !== undefined ? Caml_option.some(Caml_option.valFromOption(label)) : Belt_Option.flatMap(maybeNameAttribute, findLabelForIdOrName);
  if (maybeLabel !== undefined) {
    return Caml_option.valFromOption(maybeLabel).innerText;
  }
  var placeholder = treatBlankValueAsNone(Caml_option.nullable_to_opt(element.getAttribute("placeholder")));
  var title = treatBlankValueAsNone(Caml_option.nullable_to_opt(element.getAttribute("title")));
  var role = treatBlankValueAsNone(Caml_option.nullable_to_opt(element.getAttribute("role")));
  if (placeholder !== undefined) {
    return placeholder;
  } else if (title !== undefined) {
    return title;
  } else if (maybeNameAttribute !== undefined) {
    return maybeNameAttribute;
  } else if (role !== undefined) {
    return role;
  } else {
    return ;
  }
}

var $$EventTarget = {
  deduceNameOfInput: deduceNameOfInput
};

function optionsGet(selectElement) {
  return Array.prototype.slice.call(selectElement.options);
}

function HtmlSelectElement_fromReactEventTarget(prim) {
  return prim;
}

function HtmlSelectElement_fromElement(prim) {
  return prim;
}

function HtmlSelectElement_selectedIndexGet(prim) {
  return prim.selectedIndex;
}

var HtmlSelectElement = {
  fromReactEventTarget: HtmlSelectElement_fromReactEventTarget,
  fromElement: HtmlSelectElement_fromElement,
  selectedIndexGet: HtmlSelectElement_selectedIndexGet,
  optionsGet: optionsGet
};

var listenState_documentListeners = {};

var listenState_eventTypesWithoutCapture = {
  contents: []
};

var listenState_eventTypesWithCapture = {
  contents: []
};

var listenState = {
  documentListeners: listenState_documentListeners,
  eventTypesWithoutCapture: listenState_eventTypesWithoutCapture,
  eventTypesWithCapture: listenState_eventTypesWithCapture
};

function registerListenerForEventType(useCapture, onDOMEvent, eventType) {
  var onEvent = function ($$event) {
    var timestamp = $$event.timeStamp;
    var eventTransported;
    if ($$event.isTrusted) {
      if (eventType === "blur") {
        eventTransported = {
          TAG: /* BlurEvent */7,
          _0: "blur",
          _1: $$event
        };
      } else if (eventType === "dragenter" || eventType === "pause" || eventType === "dragover" || eventType === "invalid" || eventType === "beforeprint" || eventType === "dblclick" || eventType === "loadeddata" || eventType === "open_" || eventType === "stalled" || eventType === "volumechange" || eventType === "animationend" || eventType === "mouseout" || eventType === "loadedmetadata" || eventType === "touchmove" || eventType === "abort" || eventType === "message" || eventType === "submit" || eventType === "ratechange" || eventType === "afterprint" || eventType === "fullscreenerror" || eventType === "transitionend" || eventType === "durationchange" || eventType === "focusout" || eventType === "toggle" || eventType === "loadstart" || eventType === "mouseover" || eventType === "playing" || eventType === "resize" || eventType === "progress" || eventType === "animationstart" || eventType === "touchend" || eventType === "online" || eventType === "seeking" || eventType === "canplay" || eventType === "mouseleave" || eventType === "mouseenter" || eventType === "suspend" || eventType === "error" || eventType === "ended" || eventType === "timeupdate" || eventType === "touchstart" || eventType === "pageshow" || eventType === "select" || eventType === "touchcancel" || eventType === "reset" || eventType === "seeked" || eventType === "unload" || eventType === "pagehide" || eventType === "search" || eventType === "fullscreenchange" || eventType === "waiting" || eventType === "beforeunload" || eventType === "popstate" || eventType === "hashchange" || eventType === "mousewheel" || eventType === "offline" || eventType === "show" || eventType === "play" || eventType === "animationiteration" || eventType === "canplaythrough" || eventType === "load" || eventType === "scroll" || eventType === "storage" || eventType === "focusin" || eventType === "dragleave") {
        Curry._2(Log$SmartcutsMacros.dom.log2, "Event captured but not transported", $$event);
        eventTransported = undefined;
      } else if (eventType === "copy") {
        eventTransported = {
          TAG: /* ClipboardEvent */3,
          _0: "copy",
          _1: $$event
        };
      } else if (eventType === "drag") {
        eventTransported = {
          TAG: /* DragEvent */4,
          _0: "drag",
          _1: $$event
        };
      } else if (eventType === "drop") {
        eventTransported = {
          TAG: /* DragEvent */4,
          _0: "drop",
          _1: $$event
        };
      } else if (eventType === "click") {
        eventTransported = {
          TAG: /* MouseEvent */0,
          _0: "click",
          _1: $$event
        };
      } else if (eventType === "wheel") {
        eventTransported = {
          TAG: /* WheelEvent */5,
          _0: "wheel",
          _1: $$event
        };
      } else if (eventType === "dragstart") {
        eventTransported = {
          TAG: /* DragEvent */4,
          _0: "dragstart",
          _1: $$event
        };
      } else if (eventType === "keyup") {
        eventTransported = {
          TAG: /* KeyboardEvent */2,
          _0: "keyup",
          _1: $$event
        };
      } else if (eventType === "dragend") {
        eventTransported = {
          TAG: /* DragEvent */4,
          _0: "dragend",
          _1: $$event
        };
      } else if (eventType === "selectionchange") {
        eventTransported = {
          TAG: /* Event */9,
          _0: "selectionchange",
          _1: $$event
        };
      } else if (eventType === "keypress") {
        eventTransported = {
          TAG: /* KeyboardEvent */2,
          _0: "keypress",
          _1: $$event
        };
      } else if (eventType === "cut") {
        eventTransported = {
          TAG: /* ClipboardEvent */3,
          _0: "cut",
          _1: $$event
        };
      } else if (eventType === "mousedown") {
        eventTransported = {
          TAG: /* MouseEvent */0,
          _0: "mousedown",
          _1: $$event
        };
      } else if (eventType === "focus") {
        eventTransported = {
          TAG: /* FocusEvent */6,
          _0: "focus",
          _1: $$event
        };
      } else if (eventType === "mousemove") {
        eventTransported = {
          TAG: /* MouseEvent */0,
          _0: "mousemove",
          _1: $$event
        };
      } else if (eventType === "keydown") {
        eventTransported = {
          TAG: /* KeyboardEvent */2,
          _0: "keydown",
          _1: $$event
        };
      } else if (eventType === "change") {
        eventTransported = {
          TAG: /* ChangeEvent */8,
          _0: $$event,
          _1: $$event.target.value
        };
      } else if (eventType === "contextmenu") {
        var target = $$event.target;
        Navigator__Clipboard$SmartcutsMacros.readText(undefined).then(function (clipboardTextWhenOpened) {
              document.addEventListener("mousemove", (function (_event) {
                      var exitTimestamp = Date.now();
                      Navigator__Clipboard$SmartcutsMacros.readText(undefined).then(function (clipboardTextWhenClosed) {
                            Curry._2(onDOMEvent, exitTimestamp, {
                                  TAG: /* SyntheticEvent */10,
                                  _0: /* ContextMenuClosed */{
                                    _0: {
                                      target: target,
                                      clipboardWhenOpened: clipboardTextWhenOpened,
                                      clipboardWhenClosed: clipboardTextWhenClosed
                                    }
                                  }
                                });
                            return Promise.resolve(undefined);
                          });
                      
                    }), {
                    capture: false,
                    once: true,
                    passive: true
                  });
              return Promise.resolve(undefined);
            });
        eventTransported = {
          TAG: /* MouseEvent */0,
          _0: "contextmenu",
          _1: $$event
        };
      } else {
        eventTransported = eventType === "paste" ? ({
              TAG: /* ClipboardEvent */3,
              _0: "paste",
              _1: $$event
            }) : (
            eventType === "input" ? ({
                  TAG: /* InputEvent */1,
                  _0: "input",
                  _1: $$event
                }) : ({
                  TAG: /* MouseEvent */0,
                  _0: "mouseup",
                  _1: $$event
                })
          );
      }
    } else {
      eventTransported = undefined;
    }
    OptionUtils$SmartcutsMacros.$neg$question$great(eventTransported, Curry._1(onDOMEvent, timestamp));
    
  };
  var eventTypeStr = DOM__EventType$SmartcutsMacros.tToJs(eventType);
  listenState_documentListeners[eventTypeStr] = onEvent;
  var addEventListener = useCapture ? (function (prim0, prim1, prim2) {
        prim0.addEventListener(prim1, prim2, true);
        
      }) : (function (prim0, prim1, prim2) {
        prim0.addEventListener(prim1, prim2);
        
      });
  return Curry._3(addEventListener, document, eventTypeStr, onEvent);
}

function listen(eventTypesWithoutCaptureOpt, eventTypesWithCaptureOpt, onDOMEvent) {
  var eventTypesWithoutCapture = eventTypesWithoutCaptureOpt !== undefined ? eventTypesWithoutCaptureOpt : mvpEventTypesWithoutCapture;
  var eventTypesWithCapture = eventTypesWithCaptureOpt !== undefined ? eventTypesWithCaptureOpt : mvpEventTypesWithCapture;
  eventTypesWithoutCapture.forEach(function (param) {
        return registerListenerForEventType(false, onDOMEvent, param);
      });
  listenState_eventTypesWithoutCapture.contents = eventTypesWithoutCapture;
  eventTypesWithCapture.forEach(function (param) {
        return registerListenerForEventType(true, onDOMEvent, param);
      });
  listenState_eventTypesWithCapture.contents = eventTypesWithCapture;
  
}

function unlistenEvents(events, removeListener) {
  return $$Array.map((function (eventType) {
                var eventTypeStr = DOM__EventType$SmartcutsMacros.tToJs(eventType);
                var listener = Js_dict.get(listenState_documentListeners, eventTypeStr);
                if (listener !== undefined) {
                  return Curry._2(removeListener, DOM__EventType$SmartcutsMacros.tToJs(eventType), listener);
                } else {
                  return Util$SmartcutsMacros.logAndRaiseJsError("Expected a listener to clean up for event: " + eventTypeStr);
                }
              }), events);
}

function unlisten(param) {
  unlistenEvents(listenState_eventTypesWithoutCapture.contents, (function ($$event, listener) {
          document.removeEventListener($$event, listener);
          
        }));
  unlistenEvents(listenState_eventTypesWithCapture.contents, (function ($$event, listener) {
          document.removeEventListener($$event, listener, true);
          
        }));
  
}

function findClosestAncestorThatSatisfies(predicate, _node) {
  while(true) {
    var node = _node;
    var parent = node.parentNode;
    if (parent == null) {
      return ;
    }
    if (Curry._1(predicate, parent)) {
      return Caml_option.some(parent);
    }
    _node = parent;
    continue ;
  };
}

var NodeTraversal = {
  findClosestAncestorThatSatisfies: findClosestAncestorThatSatisfies
};

var _map$3 = {"attributes":"attributes","characterData":"characterData","childList":"childList"};

function recordTypeToJs(param) {
  return param;
}

function recordTypeFromJs(param) {
  return _map$3[param];
}

function makeOptions(attributes, attributeFilter, attributeOldValue, characterData, characterDataOldValue, childList, subtree, param) {
  var tmp = {};
  if (attributeFilter !== undefined) {
    tmp.attributeFilter = Caml_option.valFromOption(attributeFilter);
  }
  if (attributeOldValue !== undefined) {
    tmp.attributeOldValue = Caml_option.valFromOption(attributeOldValue);
  }
  if (attributes !== undefined) {
    tmp.attributes = Caml_option.valFromOption(attributes);
  }
  if (characterData !== undefined) {
    tmp.characterData = Caml_option.valFromOption(characterData);
  }
  if (characterDataOldValue !== undefined) {
    tmp.characterDataOldValue = Caml_option.valFromOption(characterDataOldValue);
  }
  if (childList !== undefined) {
    tmp.childList = Caml_option.valFromOption(childList);
  }
  if (subtree !== undefined) {
    tmp.subtree = Caml_option.valFromOption(subtree);
  }
  return tmp;
}

var ObserverInit = {
  makeOptions: makeOptions
};

var Mutation = {
  recordTypeToJs: recordTypeToJs,
  recordTypeFromJs: recordTypeFromJs,
  ObserverInit: ObserverInit
};

function findHost(_htmlElement) {
  while(true) {
    var htmlElement = _htmlElement;
    if (DOM__Element$SmartcutsMacros.isNotVisibleOnPage(htmlElement)) {
      var parent = DOM__HtmlElement$SmartcutsMacros.parentHtmlElement(htmlElement);
      if (parent === undefined) {
        return Util$SmartcutsMacros.logAndRaiseJsError("Unable to locate parent element of a invisible element when ContentEditable.findHost");
      }
      _htmlElement = Caml_option.valFromOption(parent);
      continue ;
    }
    var parent$1 = DOM__HtmlElement$SmartcutsMacros.parentHtmlElement(htmlElement);
    if (parent$1 === undefined) {
      return htmlElement;
    }
    var parent$2 = Caml_option.valFromOption(parent$1);
    if (!parent$2.isContentEditable) {
      return htmlElement;
    }
    _htmlElement = parent$2;
    continue ;
  };
}

var ContentEditable = {
  findHost: findHost
};

function stringify$2(record) {
  return "{type: " + (record.type + ", target, addedNodes, removedNodes, previousSibling, nextSibling, attributeName, attributeNamespace, oldValue}");
}

function t__encode$1(v) {
  return Js_dict.fromArray([
              [
                "type_",
                Decco.stringToJson(v.type_)
              ],
              [
                "target",
                DOM__Node$SmartcutsMacros.ForSerialization.t__encode(v.target)
              ],
              [
                "addedNodes",
                Decco.arrayToJson(DOM__Node$SmartcutsMacros.ForSerialization.t__encode, v.addedNodes)
              ],
              [
                "removedNodes",
                Decco.arrayToJson(DOM__Node$SmartcutsMacros.ForSerialization.t__encode, v.removedNodes)
              ],
              [
                "previousSibling",
                Decco.optionToJson(DOM__Node$SmartcutsMacros.ForSerialization.t__encode, v.previousSibling)
              ],
              [
                "nextSibling",
                Decco.optionToJson(DOM__Node$SmartcutsMacros.ForSerialization.t__encode, v.nextSibling)
              ],
              [
                "attributeName",
                Decco.optionToJson(Decco.stringToJson, v.attributeName)
              ],
              [
                "attributeNamespace",
                Decco.optionToJson(Decco.stringToJson, v.attributeNamespace)
              ],
              [
                "oldValue",
                Decco.optionToJson(Decco.stringToJson, v.oldValue)
              ]
            ]);
}

function t__decode$1(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var type_ = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "type_"), null));
  if (type_.TAG === /* Ok */0) {
    var target = DOM__Node$SmartcutsMacros.ForSerialization.t__decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "target"), null));
    if (target.TAG === /* Ok */0) {
      var v$1 = Belt_Option.getWithDefault(Js_dict.get(dict$1, "addedNodes"), null);
      var addedNodes = Decco.arrayFromJson(DOM__Node$SmartcutsMacros.ForSerialization.t__decode, v$1);
      if (addedNodes.TAG === /* Ok */0) {
        var v$2 = Belt_Option.getWithDefault(Js_dict.get(dict$1, "removedNodes"), null);
        var removedNodes = Decco.arrayFromJson(DOM__Node$SmartcutsMacros.ForSerialization.t__decode, v$2);
        if (removedNodes.TAG === /* Ok */0) {
          var previousSibling = Decco.optionFromJson(DOM__Node$SmartcutsMacros.ForSerialization.t__decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "previousSibling"), null));
          if (previousSibling.TAG === /* Ok */0) {
            var nextSibling = Decco.optionFromJson(DOM__Node$SmartcutsMacros.ForSerialization.t__decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "nextSibling"), null));
            if (nextSibling.TAG === /* Ok */0) {
              var attributeName = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "attributeName"), null));
              if (attributeName.TAG === /* Ok */0) {
                var attributeNamespace = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "attributeNamespace"), null));
                if (attributeNamespace.TAG === /* Ok */0) {
                  var oldValue = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "oldValue"), null));
                  if (oldValue.TAG === /* Ok */0) {
                    return {
                            TAG: /* Ok */0,
                            _0: {
                              type_: type_._0,
                              target: target._0,
                              addedNodes: addedNodes._0,
                              removedNodes: removedNodes._0,
                              previousSibling: previousSibling._0,
                              nextSibling: nextSibling._0,
                              attributeName: attributeName._0,
                              attributeNamespace: attributeNamespace._0,
                              oldValue: oldValue._0
                            }
                          };
                  }
                  var e = oldValue._0;
                  return {
                          TAG: /* Error */1,
                          _0: {
                            path: ".oldValue" + e.path,
                            message: e.message,
                            value: e.value
                          }
                        };
                }
                var e$1 = attributeNamespace._0;
                return {
                        TAG: /* Error */1,
                        _0: {
                          path: ".attributeNamespace" + e$1.path,
                          message: e$1.message,
                          value: e$1.value
                        }
                      };
              }
              var e$2 = attributeName._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".attributeName" + e$2.path,
                        message: e$2.message,
                        value: e$2.value
                      }
                    };
            }
            var e$3 = nextSibling._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".nextSibling" + e$3.path,
                      message: e$3.message,
                      value: e$3.value
                    }
                  };
          }
          var e$4 = previousSibling._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".previousSibling" + e$4.path,
                    message: e$4.message,
                    value: e$4.value
                  }
                };
        }
        var e$5 = removedNodes._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".removedNodes" + e$5.path,
                  message: e$5.message,
                  value: e$5.value
                }
              };
      }
      var e$6 = addedNodes._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".addedNodes" + e$6.path,
                message: e$6.message,
                value: e$6.value
              }
            };
    }
    var e$7 = target._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".target" + e$7.path,
              message: e$7.message,
              value: e$7.value
            }
          };
  }
  var e$8 = type_._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".type_" + e$8.path,
            message: e$8.message,
            value: e$8.value
          }
        };
}

function fromMutationRecord(record) {
  return {
          type_: record.type,
          target: DOM__Node$SmartcutsMacros.ForSerialization.fromDomNode(record.target),
          addedNodes: fromNodeList(record.addedNodes),
          removedNodes: fromNodeList(record.removedNodes),
          previousSibling: OptionUtils$SmartcutsMacros.map(Caml_option.nullable_to_opt(record.previousSibling), DOM__Node$SmartcutsMacros.ForSerialization.fromDomNode),
          nextSibling: OptionUtils$SmartcutsMacros.map(Caml_option.nullable_to_opt(record.nextSibling), DOM__Node$SmartcutsMacros.ForSerialization.fromDomNode),
          attributeName: Caml_option.nullable_to_opt(record.attributeName),
          attributeNamespace: Caml_option.nullable_to_opt(record.attributeNamespace),
          oldValue: Caml_option.nullable_to_opt(record.oldValue)
        };
}

function stringify$3(param) {
  return "{type: " + (param.type_ + (", target: " + (DOM__Node$SmartcutsMacros.ForSerialization.stringify(param.target) + (", addedNodes: " + (stringify$1(param.addedNodes) + (", removedNodes: " + (stringify$1(param.removedNodes) + (", previousSibling: " + (OptionUtils$SmartcutsMacros.withDefault("null", OptionUtils$SmartcutsMacros.map(param.previousSibling, DOM__Node$SmartcutsMacros.ForSerialization.stringify)) + (", nextSibling: " + (OptionUtils$SmartcutsMacros.withDefault("null", OptionUtils$SmartcutsMacros.map(param.nextSibling, DOM__Node$SmartcutsMacros.ForSerialization.stringify)) + (", attributeName: " + (OptionUtils$SmartcutsMacros.withDefault("null", param.attributeName) + (", attributeNamespace: " + (OptionUtils$SmartcutsMacros.withDefault("null", param.attributeNamespace) + (", oldValue: " + (OptionUtils$SmartcutsMacros.withDefault("null", param.oldValue) + "}")))))))))))))))));
}

var ForSerialization$1 = {
  t__encode: t__encode$1,
  t__decode: t__decode$1,
  fromMutationRecord: fromMutationRecord,
  stringify: stringify$3
};

var $$MutationRecord = {
  stringify: stringify$2,
  ForSerialization: ForSerialization$1
};

var EventType;

var $$DataTransfer$1;

var $$Event;

var $$Document;

var Attributes;

var $$Element;

var HtmlElement;

var HtmlInputElement;

var $$Node;

var Topology;

var $$Window;

var $$File;

var $$FileList;

var FileInputElement;

exports.EventType = EventType;
exports.mvpEventTypesWithoutCapture = mvpEventTypesWithoutCapture;
exports.mvpEventTypesWithCapture = mvpEventTypesWithCapture;
exports.MouseButtonPressed = MouseButtonPressed;
exports.$$DataTransfer = $$DataTransfer$1;
exports.tagNameToJs = tagNameToJs;
exports.tagNameFromJs = tagNameFromJs;
exports.inputTypeToJs = inputTypeToJs;
exports.inputTypeFromJs = inputTypeFromJs;
exports.$$Event = $$Event;
exports.$$ClipboardEvent = $$ClipboardEvent$1;
exports.$$Document = $$Document;
exports.Attributes = Attributes;
exports.$$Element = $$Element;
exports.HtmlElement = HtmlElement;
exports.HtmlInputElement = HtmlInputElement;
exports.HtmlAnchorElement = HtmlAnchorElement;
exports.$$Node = $$Node;
exports.$$NodeList = $$NodeList;
exports.$$EventTarget = $$EventTarget;
exports.HtmlSelectElement = HtmlSelectElement;
exports.listenState = listenState;
exports.registerListenerForEventType = registerListenerForEventType;
exports.listen = listen;
exports.unlistenEvents = unlistenEvents;
exports.unlisten = unlisten;
exports.NodeTraversal = NodeTraversal;
exports.Mutation = Mutation;
exports.ContentEditable = ContentEditable;
exports.$$MutationRecord = $$MutationRecord;
exports.Topology = Topology;
exports.$$Window = $$Window;
exports.$$File = $$File;
exports.$$FileList = $$FileList;
exports.FileInputElement = FileInputElement;
/* Log-SmartcutsMacros Not a pure module */
